interface CheckBoxButtonProps {
  options: string[];
  value: string[]; 
  onChange: (selected: string[]) => void;
  className?: string;
}

export default function CheckBoxButton({options, value, onChange, className = "" }: CheckBoxButtonProps) {

  const handleToggle = (option: string) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {

      onChange([...value, option]);
    }
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {options.map((option, index) => (
        <label key={index} className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={value.includes(option)}
            onChange={() => handleToggle(option)}
            className="hidden"
          />
          <span
            className={`w-6 h-6 flex items-center justify-center rounded-md border ${
              value.includes(option) ? "border-primaryVar bg-white" : "border-gray-300 bg-white"
            }`}
          >
            {value.includes(option) && <span className="w-[14px] h-[14px] bg-primaryVar rounded" />}
          </span>
          <span className="text-sm font-normal text-gray-600 my-0.5">{option}</span>
        </label>
      ))}
    </div>
  );
};